<ion-item lines="full" class="range-input" (click)="open = true">
  <ion-icon name="calendar-outline" slot="start" class="calendar-icon-btn"></ion-icon>
  <ion-label class="format-label">
    {{ startDate && endDate ? formatDisplay(startDate, endDate) : 'Select date & time range' }}
  </ion-label>
  <ion-icon
    *ngIf="startDate || endDate"
    name="close-circle"
    slot="end"
    (click)="clear($event)"
    class="close-icon-btn"
  ></ion-icon>
</ion-item>

<ion-popover
  [isOpen]="open"
  [backdropDismiss]="false"
  (didDismiss)="open = false"
  class="range-popover"
  [event]="null"
  [keepContentsMounted]="true"
>
  <ng-template>
    <div class="picker-header d-flex justify-content-between align-items-center">
      <div>
        <span class="picker-title">Select Range</span>
      </div>
      <div>

        <ion-button fill="clear" (click)="confirm()" [disabled]="!startDate || !endDate">
          Done
        </ion-button>

        <ion-button fill="clear" size="small" (click)="cancel()">Cancel</ion-button>
      </div>
    </div>

    <div class="picker-body">
      <div class="picker-column">
        <div class="picker-column-header">Start</div>
        <ion-datetime
          presentation="date-time"
          [value]="startDate"
          (ionChange)="onStartChange($event)"
          showDefaultButtons="true"
          doneText="Ok"
          cancelText="Cancel"
          [keepContentsMounted]="true"
        ></ion-datetime>
      </div>
      <div class="picker-column">
        <div class="picker-column-header">End</div>
        <ion-datetime
          presentation="date-time"
          [min]="startDate"
          [value]="endDate"
          showDefaultButtons="true"
          doneText="Ok"
          cancelText="Cancel"
          [keepContentsMounted]="true"
          (ionChange)="onEndChange($event)"
        ></ion-datetime>
      </div>
    </div>
  
  </ng-template>
</ion-popover>
